import {FileManager} from '../../shared/Models/FileManager';

export class DownloadFile {
  public id: number;
  public image: FileManager | number;
  public name: string;
  public download: number;
  public position: number;
}
